import type { SVGProps } from 'react';

interface BreadcrumbChevronIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

/** Breadcrumb separator: the 1px outline chevron from the breadcrumb design. */
export function BreadcrumbChevronIcon({ className, ...props }: BreadcrumbChevronIconProps) {
  return (
    <svg
      width="7"
      height="10"
      viewBox="0 0 7 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      {...props}
    >
      <path d="M0.334473 0.371582L5.33447 4.87158L0.334473 9.37158" stroke="currentColor" />
    </svg>
  );
}
